import { DatasourceObjectPosition } from '#constants/types/storyblok';

export const checkIfVideoFile = (fileName: string) => {
  const fileExt = fileName.split('.').pop() || '';
  const videoExtensions = ['webm', 'mpg', 'mpeg', 'mpe', 'mp4', 'm4p', 'm4v', 'avi', 'wmv', 'mov'];
  return videoExtensions.includes(fileExt);
};

export const convertObjectPositionToBgPosition = (input: DatasourceObjectPosition) => {
  if (input === '') {
    return 'center';
  }
  return input.replace('object-', '').replaceAll('-', ' ');
};

/**
 * Uses storyblok image cdn to scale image
 * Used for background images
 */
export const storyblokScaleImage = (input: string, width: number) => {
  return `${input}/m/${width * 2}x0/filters:format(webp)`;
};
